import { useLabels } from '../contexts/LabelsContext'
import type { StatusEntityType } from '../services/labels'

interface StatusBadgeProps {
  entityType: StatusEntityType
  status: string | null | undefined
  className?: string
}

/**
 * Renders a status pill using the org's resolved label + color for the given
 * entity type. Inline style is used for the color so industry overrides take
 * effect without needing a Tailwind class for each new color.
 */
export function StatusBadge({ entityType, status: key, className = '' }: StatusBadgeProps) {
  const { status } = useLabels()
  const { label, color } = status(entityType, key)
  return (
    <span
      className={`inline-flex items-center px-2 py-1 rounded text-xs font-medium border ${className}`}
      style={{
        color,
        borderColor: color,
        backgroundColor: `${color}1A`, // ~10% alpha tint
      }}
    >
      {label}
    </span>
  )
}
